import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import {
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { WorkReportContext } from './WorkReportForm';

import { toast, canAccess as canAccessUtil } from 'utils/helpers';
import { FormField2 as Field, CommonDialog } from 'components';

const WorkReportPercentageModal = ({ item, onClose, }) => {
  const { t } = useTranslation();
  const [percentage, setPercentage] = useState(null);
  const { itemActions } = useContext(WorkReportContext);

  const handlePercentageChange = (value) => {
    if (value === '' || (/^\d{1,3}$/.test(value) && Number(value) >= 0 && Number(value) <= 100)) {
      setPercentage(value);
    }
  };

  const handleSubmit = async () => {
    itemActions.reportQuantityPercent(item, percentage);
    onClose();
  }

  return (
    <CommonDialog
      visible
      onClose={onClose}
      maxWidth="xs"
      style={{ position: 'relative' }}
      actions={[
        <Button
          color="default"
          variant="text"
          onClick={() => onClose()}
        >
          Atšaukti
        </Button>,
        <Button
          color="primary"
          variant="contained"
          disabled={percentage === '' || percentage === null}
          onClick={() => handleSubmit()}
        >
          Vykdyti
        </Button>
      ]}
    >
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>{t('Aktuojama dalis procentais')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ paddingTop: 0 }} >
                <Field
                    name="percentage"
                    value={percentage || ''}
                    label={t('Nurodykite aktuojamą kiekio dalį procentais')}
                    required
                    onChange={(e) => handlePercentageChange(e.value)}
                    autoComplete="off"
                    type="number"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </CommonDialog>
  )
}

export default WorkReportPercentageModal;